import { concat } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import formatDate from 'ember-intl/helpers/format-date';
import ArchiveJournalEventButton from 'parog-web/components/archive-journal-event-button';
import JesHistoryTable from 'parog-web/components/jes-history-table';
import LinkToForc from 'parog-web/components/link-to-forc';
import IbdDiskChart from 'parog-web/components/mici/ibd-disk-chart';
import type Patient from 'parog-web/models/patient';
import type SemeiaSessionService from 'parog-web/services/session';
import PageContainer from 'ui-kit/components/page-container';

interface Signature {
  Args: {
    patient: Patient;
  };
}

export default class extends Component<Signature> {
  @service declare session: SemeiaSessionService;

  get title() {
    if (this.session.medic) {
      return "Historique de l'IBD-Disk";
    }
    return 'Historique de qualité de vie';
  }

  <template>
    <PageContainer @title={{this.title}}>
      <:content>
        <JesHistoryTable class='striped' @patient={{@patient}}>
          <:addLabel>Remplir un questionnaire</:addLabel>
          <:columns as |Column|>
            <Column
              @modelName='ibd-disk-survey-filled-journal-event'
              @feature='mici'
              @component='ibd-disk-survey-consult-form-details'
              @hideEditLinks={{true}}
            >
              <:label>{{if this.session.medic 'Score' 'Consulter'}}</:label>
              <:value as |je|>
                <div class='flex items-center gap-2'>
                  <span data-test-score>{{je.score}}</span>

                  {{#if this.session.medic}}
                    <LinkToForc
                      @feature='mici'
                      @component='ibd-disk-survey-consult-form'
                      @patient={{@patient}}
                      @sourceJeId={{je.id}}
                      data-test-edit-mici-filled-link={{je.id}}
                    >
                      <i class='pencil alternate primary icon'></i>
                    </LinkToForc>

                    <ArchiveJournalEventButton
                      @journalEvent={{je}}
                      @additionalInformation={{concat
                        'Cette opération entraînera la suppression du questionnaire du '
                        (formatDate je.occurredAt format='DD MMMM YYYY')
                      }}
                      class='ui tertiary fitted primary button'
                    />
                  {{else}}
                    <LinkToForc
                      @feature='mici'
                      @component='ibd-disk-survey-consult-form'
                      @patient={{@patient}}
                      @sourceJeId={{je.id}}
                      @isReadOnly={{true}}
                      data-test-read-ibd-filled-link={{je.id}}
                    >
                      <i class='eye icon primary'></i>
                      <span class='text-[0.75em]'>Voir mes réponses</span>
                    </LinkToForc>
                  {{/if}}
                </div>
              </:value>
            </Column>
            <Column @modelName='ibd-disk-survey-filled-journal-event'>
              <:label>Diagramme</:label>
              <:value as |je|>
                <IbdDiskChart @points={{je.points}} />
              </:value>
            </Column>
          </:columns>
        </JesHistoryTable>
      </:content>
    </PageContainer>
  </template>
}
